import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { programData } from '../../components/Tab/TabData';

import { Calendar, DateObject } from 'react-multi-date-picker';
import DatePickerLocales_ko from '../../components/DatePicker/DatePickerLocales_ko';
import '../../components/DatePicker/datePickerCustom.css';
import { fetchGet } from '../../hooks/fetch';
import Loading from '../Loading';

export default function Counsel() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');
	const [applicants, setApplicants] = useState([]);
	const [schedules, setSchedules] = useState([ { uid: 0, day: 0 } ]);
	
	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};
	
	const pageName = '1대1 특허상담프로그램(S.T.A.R.T.) 신청';
	
	// 캘린더
	const date = new DateObject();
	const [dateValue, setDateValue] = useState(date);

	
	function getPageData(targetDate) {
		const date = targetDate || dateValue;

		fetchGet(
			`/counsels?year=${date.year}&month=${date.month}`,
			(json) => {
				setApplicants(json.applicants);
				setSchedules(json.schedules);
				setIsLoading(false);
			}
		);
	}

	useEffect(() => {
		setIsLoading(true);
		getPageData(dateValue);
	}, [dateValue]);

	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={programData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div
							className="gs-full-calendar-con"
							id="gs-reservation-calendar"
							style={{ scrollMarginTop: '100px' }}
						>
							<ul className="state-dot-items abs">
								<li>요청</li>
								<li className="approval">승인</li>
								<li className="return">반려</li>
							</ul>
							
							{isLoading ? <Loading /> 
							:
								<Calendar
									showOtherDays
									shadow={false}
									locale={DatePickerLocales_ko}
									formatMonth={(month, year) => month}
									formatYear={(year, month) => year + '년'}
									monthYearSeparator=" "
									format="YYYY-MM-DD"
									value={dateValue}
									onMonthChange={(d) => {
										const newDate = new DateObject(d);
										setDateValue(newDate);
										getPageData(newDate);             
									}}
									// 일별 이벤트 표시
									mapDays={({ date, today }) => {
										// const showdDate = date.format();
										const showdDate = date.format("YYYY-MM-DD");

										const dayEventObj = applicants.filter(function (d) {
											return Object.values(d).indexOf(showdDate) !== -1;
										});

										let result = date.toDays() - today.toDays();
										// const abledDays = schedules?.map(s => Number(s.day));
										// const counselAbleDay = abledDays.includes(date.day);
										const abledDates = schedules?.map(s => s.date) || [];
const counselAbleDay = abledDates.includes(showdDate);

										return {
											children: (
												<>
													<i className={result < 0 ? 'day disabled' : 'day'}>
														{date.format('D')}
													</i>
													{dayEventObj.length > 0 && (
														<div className="event-items">
															<ul className="state-dot-items col sm">
																{dayEventObj?.map((event, i) => (
																	<li key={i}
																		className={event.status === "APPROVAL" ? 'approval' 
																				: event.status === "REJECT" ? 'return strike' : ''}
																	>
																		<Link to={`./../schedule/${event.uid}`}>{event.name}({event.time})</Link>
																	</li>
																))}
															</ul>
														</div>
													)}

													{result < 0 || !counselAbleDay 
														? <div className="reservation-btn">예약 불가</div>
														: <Link to="./../apply" state={{ applicationDate: showdDate }} className="reservation-btn"> 예 약 </Link>
													}
												</>
											),
										};
									}}
								>
									<button className="rmdp-calendar-today-btn" onClick={() => setDateValue(date)}>
										오늘
									</button>
								</Calendar>
							}
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
